import { showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { microsoftConstants } from '../../constant';

export const check_microsoft_auth_action = () => async (dispatch) => {
  dispatch({
    type: microsoftConstants.CHECK_MICROSOFT_AUTH_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.microsoft.checkAuth);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: microsoftConstants.CHECK_MICROSOFT_AUTH_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: microsoftConstants.CHECK_MICROSOFT_AUTH_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};
export const fetch_microsoft_email_threads_action = (id) => async (dispatch) => {
  dispatch({
    type: microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.microsoft.emailThreads(id));
    if (response.status) {
      let data = response.data;
      dispatch({
        type: microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};
